"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaCampaignGroupForAdminEntity = void 0;
class MediaCampaignGroupForAdminEntity {
    reqId;
    displayIds;
    campaignIds;
    media;
    campaignOwner;
    displayOwnerIds;
    title;
    statistics;
    dates;
    isSelf;
    mediaType;
    pricing;
    paymentLink;
    metadata;
    /** Optional manual commercial goal; independent of calculated delivery planning. */
    impressionGoal;
    status;
    mediaDuration;
    isExpired;
    updatedAt;
    createdAt;
}
exports.MediaCampaignGroupForAdminEntity = MediaCampaignGroupForAdminEntity;
